/**
 * Store registry — Tilleggsmoduler (C): stores for products that are NOT part
 * of the Dyrejournal build (race/GPS/streaming/broadcast, shooting, F1, CMS,
 * installations, coffee, courses, checklists, etc.).
 *
 * The Dyrejournal-repo export replaces this file with an empty stub
 * (`export default {};`) and removes the imported store files. Everything that
 * consumes these stores from app-level code must therefore access them
 * guarded: `otherStores.raceStore?.method()`.
 * Classification source of truth: docs/dyrejournal-separation/manifest.md
 */
import newsStore from '../stores/news';
import newsletterStore from '../stores/newsletter';
import recipientListStore from '../stores/recipientList';
import installationStore from '../stores/installation';
import partStore from '../stores/part';
import inspectionStore from '../stores/inspection';
import loanStore from '../stores/loan';

import raceStore from '../stores/race';
import raceOrganiserStore from '../stores/raceOrganiser';
import raceClassStore from '../stores/raceClass';
import raceClassContestantStore from '../stores/raceClassContestant';
import raceResultStore from '../stores/raceResult';
import raceLiveUpdateStore from '../stores/raceLiveUpdate';
import raceLiveQuestionStore from '../stores/raceLiveQuestion';
import raceLiveStandingStore from '../stores/raceLiveStanding';
import gpsPointStore from '../stores/gpsPoint';
import gpsDeviceStore from '../stores/gpsDevice';
import gpsDevicesAvailableStore from '../stores/gpsDevicesAvailable';
import streamStore from '../stores/stream';
import streamDeviceStore from '../stores/streamDevice';
import musherRatingStore from '../stores/musherRating';
import externalRaceResultStore from '../stores/externalRaceResult';

import conventionStore from '../stores/convention';
import conventionResultStore from '../stores/conventionResult';
import conventionIpscScoreStore from '../stores/conventionIpscScore';
import conventionMessageStore from '../stores/conventionMessage';
import shooterMarkStore from '../stores/shooterMark';
import conventionNoteStore from '../stores/conventionNote';
import megalinkShotStore from '../stores/megalinkShot';
import competitionResultStore from '../stores/competitionResult';
import shotCalcStore from '../stores/shotCalc';
import shotTrainerStore from '../stores/shotTrainer';
import lotTestingStore from '../stores/lotTesting';
import ammoSaleStore from '../stores/ammoSale';
import clubRoleStore from '../stores/clubRole';
import weaponCardStore from '../stores/weaponCard';
import partMaintenanceStore from '../stores/partMaintenance';
import clubKeyStore from '../stores/clubKey';
import clubTransactionStore from '../stores/clubTransaction';
import arcadeScoreStore from '../stores/arcadeScore';
import adventCalendarStore from '../stores/adventCalendar';
import examStore from '../stores/exam';
import examAttemptStore from '../stores/examAttempt';
import rubicCardStore from '../stores/rubicCard';

import timeTrackerStore from '../stores/timeTracker';
import holidayDayStore from '../stores/holidayDay';
import panelCalculatorStore from '../stores/panelCalculator';
import ffeStore from '../stores/ffe';
import workSharingItemStore from '../stores/workSharingItem';
import trophyStore from '../stores/trophy';
import yearlySummaryStore from '../stores/yearlySummaryStore';

import contentSourceStore from '../stores/contentSource';
import scrapedContentStore from '../stores/scrapedContent';
import curatedContentStore from '../stores/curatedContent';

import coffeeStore from '../stores/coffee';
import marketplaceFeedStore from '../stores/marketplaceFeed';
import nsfCompetitionStore from '../stores/nsfCompetition';
import nsfCompetitionWatchStore from '../stores/nsfCompetitionWatch';
import nsfCompetitionRsvpStore from '../stores/nsfCompetitionRsvp';
import nsfCompetitionInviteStore from '../stores/nsfCompetitionInvite';
// onThisDay: NOT part of Dyrejournal (decision 2026-07-05, manifest §9).
import onThisDayStore from '../stores/onThisDay';

import f1MeetingStore from '../stores/f1Meeting';
import f1SessionStore from '../stores/f1Session';
import f1DriverStore from '../stores/f1Driver';
import f1LiveStore from '../stores/f1Live';
import f1TelemetryStore from '../stores/f1Telemetry';

import broadcastChannelStore from '../stores/broadcastChannel';
import broadcastScheduleStore from '../stores/broadcastSchedule';
import broadcastEventStore from '../stores/broadcastEvent';
import broadcastProgramStore from '../stores/broadcastProgram';

import courseStore from '../stores/course';
import elearningCourseStore from '../stores/elearningCourse';
import elearningLessonStore from '../stores/elearningLesson';
import elearningProgressStore from '../stores/elearningProgress';
import checklistStore from '../stores/checklist';
import checklistResponseStore from '../stores/checklistResponse';

export default {
    newsStore,
    newsletterStore,
    recipientListStore,
    installationStore,
    partStore,
    inspectionStore,
    loanStore,

    raceStore,
    raceOrganiserStore,
    raceClassStore,
    raceClassContestantStore,
    raceResultStore,
    raceLiveUpdateStore,
    raceLiveQuestionStore,
    raceLiveStandingStore,
    gpsPointStore,
    gpsDeviceStore,
    gpsDevicesAvailableStore,
    streamStore,
    streamDeviceStore,
    musherRatingStore,
    externalRaceResultStore,

    conventionStore,
    conventionResultStore,
    conventionIpscScoreStore,
    conventionMessageStore,
    shooterMarkStore,
    conventionNoteStore,
    megalinkShotStore,
    competitionResultStore,
    shotCalcStore,
    shotTrainerStore,
    lotTestingStore,
    ammoSaleStore,
    clubRoleStore,
    weaponCardStore,
    partMaintenanceStore,
    clubKeyStore,
    clubTransactionStore,
    examStore,
    examAttemptStore,
    rubicCardStore,

    timeTrackerStore,
    holidayDayStore,
    panelCalculatorStore,
    ffeStore,
    workSharingItemStore,
    trophyStore,
    yearlySummaryStore,

    contentSourceStore,
    scrapedContentStore,
    curatedContentStore,

    coffeeStore,
    marketplaceFeedStore,
    nsfCompetitionStore,
    nsfCompetitionWatchStore,
    nsfCompetitionRsvpStore,
    nsfCompetitionInviteStore,
    onThisDayStore,

    f1MeetingStore,
    f1SessionStore,
    f1DriverStore,
    f1LiveStore,
    f1TelemetryStore,

    broadcastChannelStore,
    broadcastScheduleStore,
    broadcastEventStore,
    broadcastProgramStore,

    courseStore,
    elearningCourseStore,
    elearningLessonStore,
    elearningProgressStore,
    checklistStore,
    checklistResponseStore,

    arcadeScoreStore,
    adventCalendarStore,
};
